import React,{useState,useEffect} from "react"
import { Card, CardBody, Col, Row, Spinner, Table } from "reactstrap"
import ReactApexChart from "react-apexcharts"
import { getSalesChartData } from "helpers/backend_helper"

const TopSellingPft = props => {

  const [seletedMonth, setSeletedMonth] = useState("15d")
  const [loading, setLoading] = useState(false)
  const [sellingData, setSellingData] = useState([])

  useEffect(() => {
    getSalesData(seletedMonth,'salespft')
    return () => {
      setSellingData([])
    }
  }, []);

  const onChangeMonth = value => {
    setSeletedMonth(value)
    getSalesData(value,'salespft')
  }

  const getSalesData = async(input,type) => {
    setLoading(true)
    getSalesChartData({
      key : input,
      id: type
    }).then(response => {
      setSellingData(response)
      setLoading(false)
    })
  }

  const getChartOptions = index => {
    var options = {
      chart: { sparkline: { enabled: !0 } },
      dataLabels: { enabled: !1 },
      colors: ["#556ee6"],
      plotOptions: {
        radialBar: {
          hollow: { margin: 0, size: "60%" },
          track: { margin: 0 },
          dataLabels: { show: !1 },
        },
      },
    }
    switch (index) {
      case 1:
        options["colors"][0] = "#556ee6"
        break
      case 2:
        options["colors"][0] = "#34c38f"
        break
      case 3:
        options["colors"][0] = "#f46a6a"
        break
      case 4:
        options["colors"][0] = "#264653"
        break
      case 5:
        options["colors"][0] = "#2a9d8f"
        break
      case 6:
        options["colors"][0] = "#e9c46a"
        break
      case 7:
        options["colors"][0] = "#073b4c"
        break
      case 8:
        options["colors"][0] = "#e76f51"
        break
      case 9:
        options["colors"][0] = "#06d6a0"
        break
      case 10:
        options["colors"][0] = "#f4a261"
        break
      default:
        break
    }
  
    return options
  }

  return (
    <React.Fragment>
      <Col xl={6}>

        <Card>
          <CardBody>
            <div className="clearfix">
              
              
              <div className="float-end">
                <div className="input-group input-group">
                  <select
                    className="form-select form-select-sm"
                    value={seletedMonth}
                    onChange={(e) => {
                      onChangeMonth(e.target.value)
                    }}
                  >
                    <option value="7d">Last 7 Days</option>
                    <option value="15d">Last 15 Days</option>
                    <option value="30d">Last 1 Month</option>
                    <option value="90d">Last 3 Months</option>
                    <option value="180d">Last 6 Months</option>
                    <option value="365d">Last 1 Year</option>
                  </select>
                </div>
              </div>
              {loading && <div className="float-end">
               <Spinner style={{ width: '1.5rem', height: '1.5rem' }} className="mx-1" color="primary" />
              </div> 
              }
              <h4 className="card-title mb-4">Top Sales by Profit</h4>
            </div>

            <div className="table-responsive mt-4">
              <Table className="table table-sm align-middle mb-0">
                <tbody>
                  {(sellingData || []).map((data, key) => {
                    const options = getChartOptions(key + 1);
                    return (
                      <tr key={key}>
                        <td>
                          <h5 className="font-size-14 mb-1">{key + 1}</h5>
                        </td>
                        <td>
                          <h5 className="font-size-14 mb-1">{data.id}</h5>
                          <p className="text-muted mb-0">{data.name}</p>
                        </td>

                        <td>
                          <h5 className="font-size-14 mb-1 d-flex"><i className="bx bx-rupee font-size-15"></i>{Number(data.count).toLocaleString('en-IN',{minimumFractionDigits: 2})}</h5>
                        </td>

                        <td>
                          <div id="radialchart-1">
                            <ReactApexChart
                              options={options}
                              series={[data.percentage]}
                              type="radialBar"
                              height={60}
                              width={60}
                              className="apex-charts"
                            />
                          </div>
                        </td>
                        <td>
                          <h5 className="mb-0">{data.percentage} %</h5>
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </Table>
            </div>

          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  )
}

export default TopSellingPft
